/**
 * @generated SignedSource<<2796bae3ef2958bb1cb3c0eff8ff2268>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type editAccountGroupsButton_AccountFragment$data = {
  readonly " $fragmentSpreads": FragmentRefs<"editAccountGroupsForm_AccountFragment">;
  readonly " $fragmentType": "editAccountGroupsButton_AccountFragment";
};
export type editAccountGroupsButton_AccountFragment$key = {
  readonly " $data"?: editAccountGroupsButton_AccountFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"editAccountGroupsButton_AccountFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "editAccountGroupsButton_AccountFragment",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "editAccountGroupsForm_AccountFragment"
    }
  ],
  "type": "Account",
  "abstractKey": null
};

(node as any).hash = "d699e17939191315e148a101543ab855";

export default node;
